<template>
  <div>
    <div class="sys-sign-out">
      <a-dropdown>
        <div class="dropdown-trigger">
          <img class="user-avatar" src="../../assets/images/default_avatar.png" alt="avatar" />
          <div class="user-name" style="color: #fff">欢迎，{{ username }}
            <a-icon type="more" style="color: #fff; fontSize: 16px" />
          </div>
        </div>
        <!-- v-if="this.canOperate(['ChangingPassword'])" -->
        <a-menu slot="overlay">
          <a-menu-item  v-if="appId === '10016'">
            <div @click="toIndividualCenter">个人中心</div>
          </a-menu-item>
          <!-- <a-menu-item  v-if="whetherAccountExists == '1'">
            <div @click="changePW">{{ psdType != 2 ? '修改密码' : '设置账号及密码' }}</div>
          </a-menu-item> -->
          <a-menu-item  v-if="logoUi.productRecommendUrl">
            <div @click="goRecommend">关于我们</div>
          </a-menu-item>
          <a-menu-item>
            <div @click="toSignOut">退出</div>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
    <ChangePassword v-model="changePWModal" />
    <InitializeAccount v-model="initModal" />
  </div>
</template>

<script>
import { post } from '@/utils/http';
import { getLogo } from '@/utils/intConfiguration';
import { rmToken } from '@/views/login/login-handler';
import api from '@/api';
import { pointTools } from '@/utils/point';
import { canOperate } from '@/utils/utils';
import ChangePassword from './ChangePassword.vue';
import InitializeAccount from './InitializeAccount.vue'
export default {
  components: {
    ChangePassword,
    InitializeAccount,
  },
  data() {
    return {
      appId: localStorage.getItem('appId') || '',
      logoUi: getLogo(),
      username: '',
      changePWModal: false,
      initModal: false,
      psdType: 0, // 2 -设置账号密码 1&0-修改密码
      whetherAccountExists: localStorage.getItem('whetherAccountExists') || '0',
    };
  },
  created() {
    this.username = localStorage.getItem('name') || '灵播管家';
  },
  mounted() {
    this.initPsw();
  },
  methods: {
    initPsw() {
      if(this.whetherAccountExists != '1'){
        return;
      }
      post(api.queryAccountStatus, {})
      .then(res=> {
        this.psdType = res;
      })
    },
    canOperate(codes) {
      return canOperate(codes);
    },
    // 修改密码
    changePW() {
      this.psdType != 2 ? this.changePWModal = true : this.initModal = true;
    },
    // 退出
    // async toSignOut() {

    //   localStorage.removeItem('loginSource');
    //   await this.$router.push('/login');
    //   await post(api.loginOut, {}).catch(() => { });
    //   rmToken();
    //   this.isReload();
    // },
    async toSignOut() {
      try {
        const appId = localStorage.getItem('appId');
        rmToken();
        localStorage.clear();
        sessionStorage.clear();

        await post(api.loginOut, {}).catch(() => {});

        this.$router.replace('/login');
        if (['90001', '20001', '10004', '10009', '20004', '100001'].includes(appId)) {
          setTimeout(() => window.location.reload(), 100);
        }
      } catch (e) {
        console.error('退出登录异常:', e);
      }
    },

    // 判断appId
    isReload() {
      // pointTools.traceClick({
      //   event_type: 'web_click',
      //   content: {
      //     event_id: 'page_ext',
      //     event_name: '退出登录',
      //   },
      // });
      const appId = localStorage.getItem('appId');
      if (appId === '90001' || appId === '20001' || appId === '10004' || appId === '10009' || appId === '20004') {
        window.location.reload();
      }
    },
    goRecommend() {
      this.$router.push('/recommend');
    },
    toIndividualCenter() {
      this.$router.push('/IndividualCenter');
    },
  },
};
</script>
<style lang="less" scoped>
.dropdown-trigger{
  padding: 4px 10px;
  border-radius: 10px;
  background-color: #4D4DFF;
  display: flex;
  align-items: center;
  margin-right: 10px;
  cursor: pointer;
}

.user-avatar{
  width: 20px;
  height: 20px;
}

/deep/ .ant-dropdown-menu-item:hover, .ant-dropdown-menu-submenu-title:hover {
  color: rgba(0, 0, 0, 0.65);
  background-color: #EEEEFF;
}
</style>
